import { dasherize } from "../helpers";

export default {

  data () {
    return {
      id: null,
      currentLocale: Dashboard.availableLocales[0].name,
      availableLocales: Dashboard.availableLocales
    };
  },

  beforeMount () {
    if (this.name) {
      this.id = dasherize(this.name);

      if (this.isCollection()) {
        this.id = `${this.id}-${this.collectionKey()}`;
      }
    }
  },

  methods: {
    isCollection () {
      return this.$vnode.key != null;
    },

    collectionKey () {
      return this.$vnode.key;
    },

    updateValue (value) {
      let emittedValue = value;
      if (value && typeof value === "string") {
        if (value.toLowerCase() === "true") {
          emittedValue = true;
        }
        if (value.toLowerCase() === "false") {
          emittedValue = false;
        }
      }

      this.$emit("input", emittedValue);
    },

    switchLocale (locale) {
      this.currentLocale = locale;
    },

    localeInputId (locale) {
      return `${this.id}-${locale.name}`
    },

    localeInputName (locale) {
      return `${this.name.substring(0, this.name.lastIndexOf("]"))}_${locale.name}]`;
    },

    localeInputValue (locale) {
      return this.value[locale.name];
    },

    updateTranslatedValue (value, locale) {
      let emittedValue = this.value;
      emittedValue[locale.name] = value;

      this.$emit("input", emittedValue);
    }
  }
};
